<template lang="pug">
  .teaser
    .teaser-left
      img.graphers_logo(src="../assets/graphers_logo.png")
      canvas(id="canvas-webgl")
    .teaser-right
      .content
        .typo
          img.typograph(src="../assets/typo.png" height="509")
          a.register-btn(href="javascript:void(0);")
            | REGISTER WITH INSTAGRAM ACCOUNT
        .powered
          p POWERED BY
          a(href="https://twitter.com/auxout_jp" target="_blank")
            img.auxout_logo(src="../assets/auxout_logo.png" height="16")
</template>

<script>
  import Glitch from '../components/glitch.js';
  import img from '../assets/teaser.jpg';

  export default {
    name: 'Teaser',
    methods: {
      RegisterWithInstagram: function(event) {
        window.open('https://graphers.jp/instagram/redirect', 'firebaseAuth', 'height=315,width=400');
      }
    },
    mounted: function() {
      this.$nextTick(function () {
        Glitch(document.getElementById('canvas-webgl'), img)
      })
    }
  }
</script>

<style lang="scss">
  @import url('https://fonts.googleapis.com/css?family=Open+Sans:400,600');

  body {
    font-family: 'Open Sans', sans-serif;
    background-color: #fff;
  }
  .teaser {
    width: 100vw;
    height: 100vh;
    display: flex;
    overflow: hidden;
    .teaser-left, .teaser-right {
      display: flex;
      height: 100vh;
      width: 100vw;
    }
    .teaser-left {
      position: relative;
      .graphers_logo {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: scale(0.5) translate(-100%,-100%);
        filter: drop-shadow(0px 0px 8px rgba(0,0,0,0.5));
      }
    }
    .teaser-right {
      justify-content: center;
      padding: 40px 20px;
      .content {
        display: flex;
        flex-direction: column;
        text-align: center;
        .typo {
          flex: 1 1 auto;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: space-evenly;
          .register-btn {
            display: inline-block;
            color: #000;
            font-size: 16px;
            border: 3px #000 solid;
            border-radius: 0px;
            padding: 16px 24px;
            font-weight: 600;
            text-decoration: none;
            &:hover {
              background-color: #000;
              color: #fff;
            }
          }
        }
        .powered {
          flex: 0 0 auto;
          width: 100%;
          font-size: 11px;
          p {
            letter-spacing: 1px;
            margin-bottom: 8px;
          }
        }
      }
    }
  }
</style>
